import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverDayOffEntity } from '../../domain/entities/DriverDayOffEntity'

export class DriverDayOffModel extends DriverDayOffEntity {
  constructor(dataDto: DriverDayOffEntity) {
    super()
    mapEntityProperties<DriverDayOffEntity>(this, dataDto)
  }
}
